<div class="tarefas-empresa-page">
  <header class="page-hero">
    <span class="hero-icon">
      <mat-icon>task_alt</mat-icon>
    </span>
    <div class="hero-texto">
      <h1>
        Tarefas por empresa
        <span class="hero-badge">{{ totalTarefas }}</span>
      </h1>
      <p>Acompanhe suas tarefas em {{ totalCompanies }} empresa(s).</p>
    </div>

    <div class="hero-acoes">
      <button class="btn-hero" type="button" (click)="criarTarefa()">
        <mat-icon>add</mat-icon>
        Criar tarefa
      </button>
    </div>
  </header>

  <nav class="abas">
    <button
      *ngFor="let aba of abas"
      type="button"
      class="aba"
      [class.ativa]="abaAtiva === aba.key"
      (click)="selecionarAba(aba.key)"
    >
      {{ aba.label }}
      <span class="contador" *ngIf="counters[aba.key]">{{ counters[aba.key] }}</span>
    </button>
  </nav>

  <section class="filtros">
    <app-filtro-select
      [value]="filtros.targetCompanyID"
      [options]="empresas"
      (valueChange)="filtros.targetCompanyID = $event; onFiltroChange()"
    ></app-filtro-select>

    <app-filtro-select-busca
      [value]="filtros.responsibleID"
      [options]="responsaveis"
      placeholder="Todos os responsáveis"
      placeholderBusca="Buscar responsável"
      (valueChange)="filtros.responsibleID = $event; onFiltroChange()"
    ></app-filtro-select-busca>

    <app-filtro-periodo
      [intervaloSelecionado]="intervaloPeriodo"
      (intervaloSelecionadoChange)="onPeriodoChange($event)"
    ></app-filtro-periodo>

    <app-filtro-select
      [value]="filtros.moduleID"
      [options]="modulos"
      (valueChange)="filtros.moduleID = $event; onFiltroChange()"
    ></app-filtro-select>

    <app-filtro-select
      [value]="filtros.actionID"
      [options]="acoes"
      (valueChange)="filtros.actionID = $event; onFiltroChange()"
    ></app-filtro-select>

    <app-filtro-busca-texto
      [value]="filtros.name ?? ''"
      placeholder="Buscar por empresa"
      (valueChange)="onBuscaChange($event)"
    ></app-filtro-busca-texto>
  </section>

  <section class="filtros-tags" *ngIf="tagsFiltros.length">
    <span class="tags-label">Filtros aplicados:</span>

    <span class="tag-filtro" *ngFor="let tag of tagsFiltros">
      {{ tag.label }}
      <button
        type="button"
        class="btn-remover-tag"
        title="Remover filtro"
        (click)="removerFiltro(tag.key)"
      >
        &times;
      </button>
    </span>

    <button
      *ngIf="todosFiltrosSelecionados"
      type="button"
      class="btn-limpar-filtros"
      (click)="limparFiltros()"
    >
      <mat-icon>filter_alt_off</mat-icon>
      Limpar filtros
    </button>
  </section>

  <app-common-loader *ngIf="carregando"></app-common-loader>

  <section class="grupos" *ngIf="!carregando">
    <div class="grupo-empresa" *ngFor="let grupo of grupos">
      <div class="grupo-header">
        <div class="grupo-info">
          <span class="avatar">{{ iniciais(grupo.companyTradeName) }}</span>
          <div>
            <h2>
              {{ grupo.companyTradeName }}
              <span class="badge-tarefas">{{ grupo.tarefas.length }} tarefa(s)</span>
            </h2>
            <p>{{ grupo.companyName }} — {{ grupo.city }}/{{ grupo.state }}</p>
          </div>
        </div>
        <button type="button" class="btn-abrir-empresa" (click)="abrirEmpresa(grupo)">
          <mat-icon>business</mat-icon> Abrir empresa
        </button>
      </div>

      <table class="tabela-tarefas">
        <thead>
          <tr>
            <th>DATA</th>
            <th>NOME</th>
            <th>CARGO</th>
            <th>TELEFONES</th>
            <th>E-MAILS</th>
            <th>REDES SOCIAIS</th>
            <th>AÇÃO</th>
            <th>RESPONSÁVEL</th>
            <th>STATUS</th>
            <th>ANOTAÇÃO</th>
            <th>AÇÕES</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tarefa of grupo.tarefas">
            <td>{{ tarefa.followUpFormat }}</td>
            <td>{{ tarefa.contactName }}</td>
            <td>{{ tarefa.contactPosition }}</td>
            <td>
              <span *ngFor="let phone of tarefa.contactPhones; let last = last">
                {{ phone }}<span *ngIf="!last">, </span>
              </span>
            </td>
            <td>{{ tarefa.contactEmail }}</td>
            <td>
              <a *ngIf="tarefa.contactLinkedin" [href]="tarefa.contactLinkedin" target="_blank">
                <img src="assets/buscas/linkedin.svg" alt="LinkedIn" class="icone-linkedin" />
              </a>
              <span *ngIf="!tarefa.contactLinkedin">—</span>
            </td>
            <td>{{ tarefa.actionDescription }}</td>
            <td>{{ tarefa.responsibleName }}</td>
            <td>
              <span class="status" [class]="classeStatus(tarefa.statusDescription)">
                {{ tarefa.statusDescription }}
              </span>
            </td>
            <td>{{ tarefa.description }}</td>
            <td class="acoes">
              <button type="button" title="Concluir" (click)="concluirTarefa(tarefa)" *ngIf="tarefa.statusId !== 3">
                <mat-icon>check</mat-icon>
              </button>
              <button type="button" title="Editar" (click)="editarTarefa(tarefa)">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" title="Excluir" (click)="excluirTarefa(tarefa)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-paginacao-tarefas
      *ngIf="recordsCount > pageSize"
      [paginacao]="{
        page: page,
        pageFirst: 1,
        pageLast: pageLast,
        pageNext: page < pageLast ? page + 1 : page,
        pagePrev: page > 1 ? page - 1 : page,
        recordsCount: recordsCount,
        pageActive: true,
        pageSize: pageSize,
        shortcuts: 0,
        hasValue: recordsCount > 0,
        shortcutPages: [],
        records: []
      }"
      (paginaMudada)="onPageChange($event)"
    ></app-paginacao-tarefas>
  </section>
</div>
